import { render, staticRenderFns } from "./Microservices.vue?vue&type=template&id=ac9ab8f6&"
import script from "./Microservices.vue?vue&type=script&lang=js&"
export * from "./Microservices.vue?vue&type=script&lang=js&"
import style0 from "./Microservices.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports